export default __webpack_public_path__ + "static/media/gridViewMobile.5d5e3d56.svg";